import React, { createContext, useState, useContext } from "react";
import "../../toastStyle.css";

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    console.error("Error: `useToast()` must be used inside a `ToastProvider`.");
    return { addToast: () => {} }; // Prevents crashes
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const addToast = (message, type = "info", duration = 5000) => {
    const id = Date.now();
    setNotifications((prev) => [...prev, { id, message, type }]);
    setTimeout(() => removeToast(id), duration);
  };

  const removeToast = (id) => {
    setNotifications((prev) => prev.filter((toast) => toast.id !== id));
  };

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <div className="toast-container">
        {notifications.map((toast) => (
          <div key={toast.id} className={`toast toast-${toast.type}`}>
            {toast.message}
            <button className="toast-close" onClick={() => removeToast(toast.id)}>✖</button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};
